module.exports = __webpack_public_path__ + "img/pw_inhalants.80165504.png";